import type { OnboardingStatus } from './schemas';

/**
 * Pure view-derivation helpers for `OnboardingModal`. Kept out of the `.tsx`
 * file so that module stays component-only (Fast Refresh rule — see
 * apps/web/CLAUDE.md § Conventions: a `.tsx` file must export only React
 * components).
 */
export type View = 'form' | 'calendly' | 'deliveryInfo' | 'closed';

/**
 * Initial view decided once after the status query first settles. A user
 * who already completed onboarding (`formCompleted`) is never re-prompted —
 * see the onboarding-outreach-platform-question plan's non-goal on this.
 */
export function deriveInitialView(status: OnboardingStatus | null): View {
  if (!status) return 'closed';
  if (status.completedAt) return 'closed';
  if (!status.formCompleted) return 'form';
  return 'closed';
}

export function viewAfterFormSubmit(next: OnboardingStatus): View {
  if (next.completedAt) return 'deliveryInfo';
  if (next.shouldShowCalendar && !next.calendlySlotTime) return 'calendly';
  return 'deliveryInfo'; // no calendly required/needed — onboarding is done
}
